<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>
        <span style="color:rgb(0,170,221)">Dashboard /</span> Receipts & Invoices
      </p>
      <h2 class="mt-6">Receipts/Invoices</h2>
      <div class="cell">
        <v-tabs>
            <v-tab>Doctors</v-tab>
            <v-tab>Patients</v-tab>
            <v-tab>Insurance Companies</v-tab>
            <v-tab>Healthcare Facilities</v-tab>
            <v-tab>Ambulance Companies</v-tab>

            <v-tab-item class="px-2">
                <DoctorsInvoices/>
            </v-tab-item>
            <v-tab-item>Patients</v-tab-item>
            <v-tab-item>Insurance Companies</v-tab-item>
            <v-tab-item>Healthcare Facilities</v-tab-item>
            <v-tab-item>Ambulance Companies</v-tab-item>
            
        </v-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import DoctorsInvoices from '@/views/invoices/DoctorsInvoices.vue';
export default {
    components: {
        DoctorsInvoices
    }
}
</script>